<template>
  <!-- Page Title -->
  <section class="page-title centred" style="background-image: url(assets/images/background/page-title.jpg);">
      <div class="shape" style="background-image: url(assets/images/shape/banner-shap.png);"></div>
      <div class="auto-container">
          <div class="content-box">
              <h1>About Us</h1>
              <ul class="bread-crumb clearfix">
                  <li><router-link to="/">Home</router-link></li>
                  <li>About Us</li>
              </ul>
          </div>
      </div>
  </section>
  <!-- End Page Title -->

  <!-- about-section -->
  <section class="about-section pb-5">
      <div class="auto-container">
          <div class="row align-items-center clearfix">
              <div class="col-lg-6 col-md-12 col-sm-12 image-column">
                  <figure class="image-box clearfix wow fadeInLeft animated" data-wow-delay="00ms" data-wow-duration="1500ms"><img src="/assets/images/product/wasewater.png" alt="about us"></figure>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div class="content_block_1">
                      <div class="content-box wow fadeInRight animated" data-wow-delay="00ms" data-wow-duration="1500ms">
                          <div class="sec-title">
                              <!-- <h2>WE ALWAYAS WANT PROTECTING TOMORROW AND HEALTHY FUTURE</h2> -->
                              <h2>We Always Want Protecting Tomorrow And Healthy Future</h2>
                          </div>
                          <div class="text">
                              <p>Akshar Watertech, established in 2011, is a company specializing in water and wastewater treatment solutions. Akshar Watertech Management and employees have expertise in various water treatment applications. Akshar Watertech has product range in water & waste water treatment plant, Water Treatment chemical, Ro Accessories, Equipment and Operation and maintenance contract.</p>
                              <p>Akshar Watertech has supplied RO plants that range from 2 M3/Hr. to 100 M3/Hr. to various different industries. We have more than 300++ satisfied customer based with different segment like Foods, Pharma, Textiles, chemical, Auto. Process.</p>                              
                          </div>
                          <div class="btn-box">
                              <router-link to="/contact-us" class="theme-btn btn-one">Contact Us</router-link>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <!-- about-section end -->

  <!-- service-details -->
<section class="service-details pt-5 pb-1">
    <div class="auto-container">
        <div class="row clearfix">
            <div class="col-lg-12 col-md-12 col-sm-12 content-side">
                <div class="service-details-content">                    
                    <div class="content-two">
                        <div class="text">                            
                            <p>We at Akshar Watertech have been extending our services in terms of Water & Waste Treatment Plant as Filtration, Softener, RO Plant, Nano Filtration, DM Plant, STP, and ETP.</p>
                              <p>We undertake O & M contracts for water and wastewater treatment plants. With more than 150 plant troubleshooting experiences in India, we have been extending our unmatchable technical support to customers across Gujarat. </p>
                        </div>                       
                    </div>                   
                </div>
            </div>            
        </div>
    </div>
</section>
<!-- service-details end -->

<section class="pricing-section pb-5">
    <div class="auto-container">
        <div class="row clearfix">
            <div class="col-lg-12 col-md-12 col-sm-12 pricing-block">
                <div class="pricing-block-one">
                    <div class="pricing-table">                        
                        <div class="table-header">                            
                            <div class="title text-dark">
                                <h3>Advantages to go with Akshar Watertech</h3>
                            </div>
                        </div>
                        <div class="table-content">
                            <ul class="feature-list clearfix">
                                <li>Audit of existing plant and recommendations to improve plant performance, compared to previous data.</li>
                                <li>Sharing of best operating practices and training to O&M staff to ensure that correct operating procedures are followed. </li>
                                <li>Continuous monitoring of operating data and time to time technical inputs on operational excellence. </li>
                                <li>Review of existing CIP practice and to suggest most effective CIP protocol </li>
                                <li>Important technical support to enhance life of UF and RO membranes.</li>
                                <li>Optimization of operating cost (Opex) through MOC (mechanical, operation & Chemical) approach. Reduced CIP frequency increases membrane life. </li>
                            </ul>                            
                        </div>   
                        <!-- <p>Note: MBR and West water point focusable</p>                      -->
                    </div>
                </div>
            </div>            
        </div>
    </div>
</section>

<section class="pricing-section">
    <div class="auto-container">
        <div class="row clearfix">
            <div class="col-lg-12 col-md-12 col-sm-12 pricing-block">
                <div class="pricing-block-one">
                    <div class="pricing-table">                        
                        <div class="table-header">                            
                            <div class="title text-dark">
                                <h3>We offer specialize in innovative wastewater treatment solutions</h3>
                            </div>
                        </div>
                        <div class="table-content">
                            <ul class="feature-list clearfix">
                                <li>Industrial RO plant</li>
                                <li>Ultra Filtration and Nano Filtration Plant</li>
                                <li>ZLD – Eco-friendly, complete water recovery </li>
                                <li>ETP & STP – Custom-designed for all industries</li>
                                <li>MBR – Compact & efficient for high-quality water (A Membrane Bioreactor)</li>
                            </ul>
                        </div>                        
                    </div>
                </div>
            </div>            
        </div>
    </div>
</section>

</template>
<script setup>
import { onMounted } from 'vue'
import { useHead } from '@unhead/vue'
useHead({
  title: 'About Us - Akshar Watertech',
  meta: [
    {
      name: 'description',
      content: 'Welcome to Akshar.',
    },
  ],
})

onMounted(() => {
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
    // Replace it: remove and re-add
    existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)

})
</script>
<style scoped>
.pricing-block-one{
    max-width: none;
}
.pricing-block-one .pricing-table .title{
    max-width: 100%;
}
.pricing-block-one .pricing-table .table-header {
    padding-bottom: 10px;
}
.pricing-block-one .pricing-table h3{
    color: #061a3a;
}
</style>